import React from 'react'
import Typography from 'material-ui/Typography'
import { MaxWidthContainer } from '../helpers/layout'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({
  welcome: {
    paddingLeft: 2 * theme.spacing.unit,
    paddingRight: 2 * theme.spacing.unit
  }
})

export default withStyles(styles)(({ classes }) => (
  <MaxWidthContainer>
    <div className={classes.welcome}>
      <Typography paragraph type="display1">
        Welcome!
      </Typography>
      <Typography paragraph type="body1">
        <strong>SecNotes</strong> is a minimalistic notes application, that
        enables to store your notes end-to-end encrypted in the Cloud.
      </Typography>
      <Typography paragraph type="body1">
        Only you have the password to decrypt your notes locally, nobody else
        can see what you write, not even with access to the storage servers.
      </Typography>
      <Typography paragraph type="caption">
        SecNotes is open source. Look at the source code and contribute on{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://github.com/scastiel/secnotes"
        >
          GitHub
        </a>.
      </Typography>
    </div>
  </MaxWidthContainer>
))



// WEBPACK FOOTER //
// ./src/components/Welcome.js